import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Email from "../../components/Settings/Email";
import Notification from "../../components/Settings/Notification";
import PaymentMethod from "../../components/Settings/PaymentMethod";
import TermsAndConditions from "../../components/Settings/TermsAndConditions";
import Support from "../../components/Settings/Support";
import PrivacyAndPolicy from "../../components/Settings/PrivacyAndPolicy";
import TalentPassWord from "../../components/Talent/TalentPassWord";

const Settings = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const getQueryParam = (key) => {
    return new URLSearchParams(location.search).get(key);
  };

  const [activeTab, setActiveTab] = useState(
    getQueryParam("subTab") || "password"
  );

  useEffect(() => {
    const subTab = getQueryParam("subTab");
    if (subTab) {
      setActiveTab(subTab);
    }
  }, [location.search]);

  const tabs = [
    { id: "password", label: t("c_s_tab1") }, // "Change Password"
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "account":
        return <Email />;
      case "password":
        return <TalentPassWord />;
      case "notification":
        return <Notification />;
      case "paymentMethod":
        return <PaymentMethod />;
      case "privacyAndPolicy":
        return <PrivacyAndPolicy />;
      case "termsAndConditions":
        return <TermsAndConditions />;
      case "support":
        return <Support />;
      default:
        return <Email />;
    }
  };

  return (
    <div className="inter-font mb-5" style={{ minHeight: "100vh" }}>
      <div
        className="inter-font container pb-4 ps-4 bg-white rounded-2 shadow mt-4"
        style={{ 
          maxWidth: "900px",
          direction: isRTL ? "rtl" : "ltr" // Added direction
        }}
      >
        <div className="inter-font row align-items-start">
          {/* Sidebar */}
          <div
            className="inter-font col-md-3 pt-5 pe-0"
            style={{ 
              borderRight: isRTL ? "none" : "1.5px solid rgb(229, 229, 229)",
              borderLeft: isRTL ? "1.5px solid rgb(229, 229, 229)" : "none",
              paddingLeft: isRTL ? "20px" : "0",
              paddingRight: isRTL ? "0" : "20px"
            }}
          >
            <h5 
              className="inter-font pt-4"
              style={{ 
                textAlign: isRTL ? "right" : "left",
                paddingRight: isRTL ? "15px" : "0"
              }}
            >
              {t("t_menu_text5")} {/* Settings */}
            </h5>
            <div className="inter-font mb-3">
              {tabs.map((tab) => (
                <div
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`inter-font my-5 border-bottom w-100 pb-4 ${
                    activeTab === tab.id
                      ? "text-dark fw-semibold"
                      : "text-muted"
                  }`}
                  style={{
                    cursor: "pointer",
                    color: activeTab === tab.id ? "#000" : "#909090",
                    width: "fit-content",
                    textAlign: isRTL ? "right" : "left",
                    marginRight: isRTL ? "auto" : "0",
                    marginLeft: isRTL ? "0" : "auto",
                    paddingRight: isRTL ? "15px" : "0"
                  }}
                >
                  {tab.label}
                </div>
              ))}
            </div>
          </div>

          {/* Content */}
          <div 
            className="inter-font col-md-9"
            style={{
              paddingLeft: isRTL ? "0" : "20px",
              paddingRight: isRTL ? "20px" : "0"
            }}
          >
            <div 
              className="inter-font tab-content mt-4"
              style={{
                textAlign: isRTL ? "right" : "left"
              }}
            >
              {renderContent()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;